<script lang="ts" setup>
// Modal genérico de 3 botones (cancelar / acción secundaria outline / acción principal sólida), para decisiones de
// 3 caminos. Lo renderizan `confirmUnsavedChanges()` (volver / salir sin guardar / guardar y salir) y
// `confirmActivateCampaign()` (volver / guardar como borrador / confirmar y activar) y `confirmReserveDraft()`
// (cancelar / no reservar / reservar) de
// `@/composables/modalHelper.ts` (no se instancia a mano) — cada una pasa sus propios labels vía
// `cancelText`/`secondaryText`/`primaryText`. Ver uso en `RetailMediaNewCampaign.vue`.
import PolyButton from '../components/poly/PolyButton.vue'

const props = withDefaults(defineProps<{
  title: string,
  text: string,
  resolve: (value: 'primary' | 'secondary' | 'cancel') => void,
  cancelText?: string,
  secondaryText?: string,
  primaryText?: string,
  secondaryColor?: 'Red' | 'Primary',
}>(), {
  secondaryColor: 'Primary',
})
</script>
<template>
  <section class="unsaved-modal">
    <span class="title">{{ title }}</span>
    <span class="text">{{ text }}</span>
    <div class="actions">
      <poly-button button-style="Blank" @click.prevent="props.resolve('cancel')">{{ $t(cancelText || 'VOLVER') }}</poly-button>
      <poly-button button-style="Outline" :button-color="secondaryColor" @click.prevent="props.resolve('secondary')">
        {{ $t(secondaryText || 'SALIR SIN GUARDAR') }}
      </poly-button>
      <poly-button @click.prevent="props.resolve('primary')">
        {{ $t(primaryText || 'GUARDAR Y SALIR') }}
      </poly-button>
    </div>
  </section>
</template>
<style scoped lang="less">
.unsaved-modal {
  background-color: white;
  width: max-content;
  max-width: calc(100vw - 2em);
  border-radius: 0.923em;
  padding: 2.462em 1.846em;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.538em;
  text-align: center;

  .title {
    font-size: 1.308em;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.4;
  }

  .text {
    font-size: 1em;
    color: #999;
    max-width: 30.769em;
  }

  .actions {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: nowrap;
    gap: 0.62em;

    :deep(button) {
      min-width: 0;
      white-space: nowrap;
      padding: 0.61em 0.92em;
    }
  }
}
</style>
